import {ChangeDetectionStrategy, Component, effect, Injectable, input, signal, viewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {EnkelGruppeModell, GruppeId, ÅrshjulInnslagModell, ÅrshjulRessursClient} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {ÅrshjulInnslagRedigerListeKomponent} from "../årshjul-innslag-rediger-liste/årshjul-innslag-rediger-liste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {KortTittelKomponent} from "web-ng2/delt/komponenter/kort/kort-tittel/kort-tittel";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {MatIcon} from "@angular/material/icon";
import {ÅrshjulGrafUtenMøterKomponent} from "web-ng2/moduler/årshjul/komponenter/årshjul-graf-uten-møter/årshjul-graf-uten-møter";
import {Gruppedata} from "web-ng2/moduler/årshjul/komponenter/årshjul-graf/ÅrshjulGraf";
import {ÅrshjulModell} from "web-ng2/moduler/årshjul/komponenter/årshjul-graf/ÅrshjulModell";
import {Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";

const debug = initDebugger('ÅrshjulOppsettKomponent');

@Component({
    selector: 'aarshjul-oppsett',
    templateUrl: 'årshjul-oppsett.html',
    styleUrl: 'årshjul-oppsett.scss',
    host: {'data-testid': 'årshjul-oppsett'},
    imports: [
        ÅrshjulInnslagRedigerListeKomponent,
        MatButtonModule,
        TranslateModule,
        KortKomponent,
        KortTittelKomponent,
        KortHandlingerKomponent,
        HtmlFormatertKomponent,
        MatIcon,
        ÅrshjulGrafUtenMøterKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ÅrshjulOppsettKomponent {

    kortKomp = viewChild.required(KortKomponent);

    gruppeId = input.required<GruppeId>();

    innslag = signal<ÅrshjulInnslagModell[]>([]);
    visning = signal(true);
    viserDiagram = signal(false);
    aarshjuldata = signal<Gruppedata[]>([]);

    constructor(private avhengigheter: ÅrshjulOppsettKomponentAvhengigheter, private oversettelser: Oversettelser, private brukerkontekst: BrukerkontekstTilbyder) {
        effect(() => {
            debug('laster årshjulinnslag for', this.gruppeId());
            this.avhengigheter.hentInnslag(this.gruppeId())
              .then(innslag => this.settInnslag(innslag));
        });
    }


    visDetaljer() {
        this.kortKomp().setSomAktivOgSkrollTil();
    }

    skjulDetaljer() {
        this.kortKomp().setSomIkkeAktiv();
    }

    rediger() {
        this.visning.set(false);
    }

    redigeringFerdig(oppdaterteInnslag: ÅrshjulInnslagModell[] | null) {
        if (oppdaterteInnslag !== null)
            this.settInnslag(oppdaterteInnslag);

        this.visning.set(true);
        this.kortKomp().skrollTil();
    }

    // private hjelpemetoder

    private settInnslag(innslag: ÅrshjulInnslagModell[]) {
        this.innslag.set(innslag)
        this.oppdaterÅrshjulinnslag(innslag)
    }

    private async oppdaterÅrshjulinnslag(innslag: ÅrshjulInnslagModell[]): Promise<void> {
        const modell = ÅrshjulModell.opprettFraÅrshjulinnslagOgMøter(innslag, [], this.oversettelser);
        modell.setGrupper([this.gruppe()])
        this.aarshjuldata.set(await modell.dataForAlleÅrshjulRinger());
    }

    private gruppe(): EnkelGruppeModell {
        return this.brukerkontekst.autentisertBruker().finnAutentiserteGruppe(this.gruppeId())!;
    }
}

@Injectable()
export class ÅrshjulOppsettKomponentAvhengigheter {

    constructor(private årshjulRessurs: ÅrshjulRessursClient) {
    }

    hentInnslag(gruppeId: GruppeId): Promise<ÅrshjulInnslagModell[]> {
        return this.årshjulRessurs.hentAlle(gruppeId).somPromise();
    }
}
